/**
 * @ngdoc directive
 * @name ng.directive:ngSearch
 * @element ANY
 * @function Suggestions directive
 * @todo - ADD: data-chars="2" to set the min search
 * @todo - return search in progress to add loader
 */

const ngSearch = ['$rootScope', '$http', '$compile', '$templateRequest', function ($rootScope, $http, $compile, $templateRequest ) {
    return {
        link: function ( $scope, $item, $params ) {

            $item = $item[0];


            let $attribute = $params.hasOwnProperty('name') ? $params.name : 'q';
            let $focused =$rootScope[$params.model].hasOwnProperty('focused') ?$rootScope[$params.model].focused : false;
            if ( $focused ) {
                $item.focus();
            }

            $rootScope[$params.model] = {
                query: '',
                active: -1,
                items: [],
                stop: false,
                loading: false,
                typing: false,
                focused: $focused,
                persist: $params.hasOwnProperty('persist'),
                counter: 0,
                results: [],
                indexes: [],
                prevent: function() {
                    this.stop = true;
                },
                reset: function () {
                    this.active = -1;
                    this.query = '';
                    this.counter = 0;
                    this.results = [];
                    this.indexes = [];
                    this.loading = false;
                },
                blur: function () {
                    window.setTimeout ( function() {
                        this.focused = false;
                        $rootScope.$apply();
                    }, 200 );
                },
                focus: function () {
                    this.focused = true;
                }
            };

            $item.addEventListener('focus', function () {
               $rootScope[$params.model].stop = false;
            }, { passive: true });

            if ($rootScope[$params.model].persist === false ) {
                $item.addEventListener('blur', function () {
                    window.setTimeout ( function() {
                       $rootScope[$params.model].reset();
                       $rootScope.$apply();
                    },  400 );
                }, { passive: true });
            }

            $item.addEventListener('keyup', function (event) {
               $rootScope[$params.model].typing = true;
              //
                event.stopPropagation();
                switch ( event.key) {
                    case 'Enter':
                       $rootScope[$params.model].reset();
                        $item.blur();
                        break;
                    case 'ArrowUp':
                        event.preventDefault();
                        $rootScope[$params.model].active = ( 0 < $rootScope[$params.model].active ) ? $rootScope[$params.model].active - 1 : $rootScope[$params.model].active;
                        $rootScope[$params.model].query = $rootScope[$params.model].indexes[$rootScope[$params.model].active];
                        $scope.$apply();
                        break;
                    case 'ArrowDown':
                        event.preventDefault();
                        $rootScope[$params.model].active = ($rootScope[$params.model].active < $rootScope[$params.model].counter - 1 ) ? $rootScope[$params.model].active + 1 : $rootScope[$params.model].active;
                        $rootScope[$params.model].query = $rootScope[$params.model].indexes[$rootScope[$params.model].active];
                        $scope.$apply();
                        break;
                    case 'Escape':
                       $rootScope[$params.model].reset();
                        break;
                    default:
                       $rootScope[$params.model].query = $item.value;
                        go();
                        break;
                }
                $scope.$apply();
            }, { passive: true });



            let go =  function() {
                if ($rootScope[$params.model].typing === false) {
                    return false;
                }
                if ($scope.timer) {
                    clearTimeout($scope.timer);
                }

                if ($rootScope[$params.model].stop) {
                    return false;
                }

                $rootScope[$params.model].results.active = -1;
                $rootScope[$params.model].results = [];
                $rootScope[$params.model].indexes = [];

                if ( 2 <= $rootScope[$params.model].query.length) {
                    $scope.timer = window.setTimeout(function () {
                       $rootScope[$params.model].loading = true;
                        let q = {};
                        q[$attribute] = $rootScope[$params.model].query;
                        $http.get($params.ngSearch, {params: q}).then(function (response) {
                            if (response.data.hasOwnProperty('counter')) {
                               $rootScope[$params.model].counter = parseInt(response.data.counter);
                            }
                            if (response.data.hasOwnProperty('results')) {
                               $rootScope[$params.model].results = response.data.results;
                                 angular.forEach(response.data.results, (source) => {
                                     angular.forEach(source.items, (item) => {
                                         $rootScope[$params.model].indexes.push(item.text);
                                     });
                                 });
                            } else {
                               $rootScope[$params.model].results = [];
                                $rootScope[$params.model].indexes = [];
                            }
                           $rootScope[$params.model].loading = false;
                        });
                    }, 200);
                }


            }
        }
    };
}];

export default ngSearch;
